import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';
import { FAQ_ITEMS } from '@/lib/seoSchemas';
import { sectionCls } from '@/pages/launch/helpers';

interface LaunchFaqSectionProps {
  sectionRef: React.Ref<HTMLDivElement>;
  visible: boolean;
}

const LaunchFaqSection = ({ sectionRef, visible }: LaunchFaqSectionProps) => (
  <section
    ref={sectionRef}
    className={`py-12 sm:py-20 px-4 sm:px-6 bg-muted/30 ${sectionCls(visible)}`}
  >
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-10">
        <Badge variant="outline" className="mb-4">
          FAQ
        </Badge>
        <h2 className="text-3xl sm:text-4xl font-display font-bold">Common Questions</h2>
      </div>
      <Accordion type="single" collapsible className="space-y-3">
        {FAQ_ITEMS.map((item, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="border border-border rounded-xl px-5 data-[state=open]:bg-card"
          >
            <AccordionTrigger className="text-left text-sm sm:text-base font-semibold hover:no-underline py-4">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-4">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default LaunchFaqSection;
